module.exports = __webpack_public_path__ + "f721466883998665b87923b92dea655b.svg";